import { get } from 'lodash'

export const getVoucherSessionId = state => get(state, 'voucher.sessionId')
export const getVoucherData = state => get(state, 'voucher')
export const getVoucherDataByUser = (state, args) => get(state, `voucher.${args[0]}`)
export const getAppliedVouchers = state => {
  const allVouchers = get(state, 'voucher')
  return Object.entries(allVouchers).reduce((acc, [key, voucher]) => {
    if (key !== 'sessionId' && voucher.appliedVoucher) {
      acc[key] = voucher
    }
    return acc
  }, {})
}
